var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _c(
        "sm-viewer",
        {
          attrs: {
            "scene-url": _vm.sceneUrl,
            tilesUrl: _vm.tilesUrl,
            center: _vm.center
          },
          on: { click: _vm.clickViewer, clickPos: _vm.clickPos }
        },
        [
          _c("sm3d-measure"),
          _vm.fan ? _c("sm3d-fan", { attrs: { points: _vm.fan } }) : _vm._e(),
          _vm.fly
            ? _c("sm3d-fly", { ref: "fly", attrs: { points: _vm.flyPoints } })
            : _vm._e(),
          _vm.graphics
            ? _c("sm3d-graphics", {
                attrs: {
                  data: _vm.graphics,
                  zoomToFirst: _vm.zoomToFirstGraphic
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c("sm3d-lat-lng")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }